'use client';

import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { MdOutlineRequestQuote } from 'react-icons/md';
import { useQuoteRequest } from '@/contexts/QuoteRequestContext';

const QuoteRequestBanner = () => {
  const { openModal } = useQuoteRequest();

  return (
    <Flex
      align="center"
      justify="space-between"
      gap="16px"
      flexDir={{ base: 'column', md: 'row' }}
      textAlign={{ base: 'center', md: 'left' }}
      px={{ base: '20px', md: '32px' }}
      py="22px"
      borderRadius="20px"
      bg="linear-gradient(135deg, #0A1B2B 0%, #00B0CA 100%)"
      boxShadow="0 8px 30px rgba(0,176,202,0.25)"
    >
      <Flex align="center" gap="14px" flexDir={{ base: 'column', md: 'row' }}>
        <Flex
          w="48px"
          h="48px"
          flexShrink={0}
          align="center"
          justify="center"
          borderRadius="14px"
          bg="rgba(255,255,255,0.15)"
        >
          <Icon fontSize="24px" color="#fff">
            <MdOutlineRequestQuote />
          </Icon>
        </Flex>
        <Flex flexDir="column" gap="2px">
          <Text fontSize={{ base: '16px', md: '18px' }} fontWeight="700" color="#fff">
            Peça já o seu orçamento
          </Text>
          <Text fontSize="13px" color="rgba(255,255,255,0.8)">
            Escolha a sua loja e o tipo de lente pretendido.
          </Text>
        </Flex>
      </Flex>
      <Button
        onClick={openModal}
        flexShrink={0}
        h="46px"
        px="28px"
        borderRadius="full"
        bg="#fff"
        color="#0A1B2B"
        fontWeight="700"
        fontSize="14px"
        transition="all 0.2s"
        _hover={{ bg: 'rgba(255,255,255,0.9)', transform: 'scale(1.03)' }}
      >
        Pedir Orçamento
      </Button>
    </Flex>
  );
};

export default QuoteRequestBanner;
